"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwapQuoter = void 0;
const abi_1 = require("@ethersproject/abi");
const amm_1 = require("@sushiswap/amm");
const QuoterV2_json_1 = __importDefault(require("@uniswap/swap-router-contracts/artifacts/contracts/lens/QuoterV2.sol/QuoterV2.json"));
const Quoter_json_1 = __importDefault(require("@uniswap/v3-periphery/artifacts/contracts/lens/Quoter.sol/Quoter.json"));
const tiny_invariant_1 = __importDefault(require("tiny-invariant"));
const utils_1 = require("./utils");
/**
 * Represents the Uniswap V3 QuoterV1 contract with a method for returning the formatted
 * calldata needed to call the quoter contract.
 */
class SwapQuoter {
    static V1INTERFACE = new abi_1.Interface(Quoter_json_1.default.abi);
    static V2INTERFACE = new abi_1.Interface(QuoterV2_json_1.default.abi);
    /**
     * Produces the on-chain method name of the appropriate function within QuoterV2,
     * and the relevant hex encoded parameters.
     * @template TInput The input token, either Ether or an ERC-20
     * @template TOutput The output token, either Ether or an ERC-20
     * @param route The swap route, a list of pools through which a swap can occur
     * @param amount The amount of the quote, either an amount in, or an amount out
     * @param tradeType The trade type, either exact input or exact output
     * @param options The optional params including price limit and Quoter contract switch
     * @returns The formatted calldata
     */
    static quoteCallParameters(route, amount, tradeType, options = {}) {
        const singleHop = route.pools.length === 1;
        const quoteAmount = (0, utils_1.toHex)(amount.quotient);
        let calldata;
        const swapInterface = options.useQuoterV2 ? this.V2INTERFACE : this.V1INTERFACE;
        if (singleHop) {
            const baseQuoteParams = {
                tokenIn: route.tokenPath[0].address,
                tokenOut: route.tokenPath[1].address,
                fee: route.pools[0].fee,
                sqrtPriceLimitX96: (0, utils_1.toHex)(options?.sqrtPriceLimitX96 ?? 0),
            };
            const v2QuoteParams = {
                ...baseQuoteParams,
                ...(tradeType == amm_1.TradeType.EXACT_INPUT ? { amountIn: quoteAmount } : { amount: quoteAmount }),
            };
            const v1QuoteParams = [
                baseQuoteParams.tokenIn,
                baseQuoteParams.tokenOut,
                baseQuoteParams.fee,
                quoteAmount,
                baseQuoteParams.sqrtPriceLimitX96,
            ];
            const tradeTypeFunctionName = tradeType === amm_1.TradeType.EXACT_INPUT ? 'quoteExactInputSingle' : 'quoteExactOutputSingle';
            calldata = swapInterface.encodeFunctionData(tradeTypeFunctionName, options.useQuoterV2 ? [v2QuoteParams] : v1QuoteParams);
        }
        else {
            (0, tiny_invariant_1.default)(options?.sqrtPriceLimitX96 === undefined, 'MULTIHOP_PRICE_LIMIT');
            const path = (0, utils_1.encodeRouteToPath)(route, tradeType === amm_1.TradeType.EXACT_OUTPUT);
            const tradeTypeFunctionName = tradeType === amm_1.TradeType.EXACT_INPUT ? 'quoteExactInput' : 'quoteExactOutput';
            calldata = swapInterface.encodeFunctionData(tradeTypeFunctionName, [path, quoteAmount]);
        }
        return {
            calldata,
            value: (0, utils_1.toHex)(0),
        };
    }
}
exports.SwapQuoter = SwapQuoter;
//# sourceMappingURL=quoter.js.map